<template>
  <section id="buttons">
    <div class="demo">
      <div class="row">
        <div class="col-lg-6">
          <h5>Default</h5>
          <p>
            <button type="button" class="btn btn-primary">Primary</button>&nbsp;
            <button type="button" class="btn btn-danger">Danger</button>
            <button type="button" class="btn btn-link">Button link</button>
          </p>
          <h5 class="mt-5">Outline</h5>
          <p class="mb-1"><code>.btn-outline-*</code></p>
          <p>
            <button type="button" class="btn btn-outline-primary">Secondary</button>&nbsp;
            <button type="button" class="btn btn-outline-danger">Danger</button>
          </p>
          <h5 class="mt-5">Loading state</h5>
          <p class="mb-1"><code>.loading</code></p>
          <p>
            <button type="button" class="btn btn-primary loading">Loading</button>&nbsp;
            <button type="button" class="btn btn-danger loading">Deleting</button>
          </p>
          <h5 class="mt-5">Sizes</h5>
          <p class="mb-1"><code>.btn-sm</code></p>
          <button type="button" class="btn btn-primary">Default</button> &nbsp;
          <button type="button" class="btn btn-primary btn-sm">Small</button>
          <h5 class="mt-5">Disabled</h5>
          <p class="mb-1"><code>disabled</code></p>
          <p>
            <button type="button" class="btn btn-primary" disabled="disabled">Primary</button>&nbsp;
            <button type="button" class="btn btn-danger" disabled="disabled">Danger</button>&nbsp;
            <button type="button" class="btn btn-outline-primary disabled">Secondary</button>&nbsp;
            <button type="button" class="btn btn-outline-danger disabled">Danger</button>&nbsp;
          </p>
          <h5 class="mt-5">Block</h5>
          <p class="mb-1"><code>.btn-block</code></p>
          <button type="button" class="btn btn-primary btn-block">Block level button</button>
          <button type="button" class="btn btn-outline-primary btn-block">Block level button</button>
        </div>
        <div class="col-lg-6">
          <h5>Controls</h5>
          <p class="mb-1"><code>.btn-ctrl .btn-icon</code></p>
          <p>
            <button class="btn btn-ctrl" type="button">
              <i aria-hidden="true" class="gel-icon-settings"></i>
              Settings
            </button>&nbsp;
            <button type="button" class="btn btn-icon" aria-label="print">
              <i
                class="gel-icon-print"
                data-toggle="tooltip"
                data-placement="top"
                data-original-title="Print"
              ></i>
            </button>&nbsp;
          </p>
          <div class="dropdown">
            <button
              class="btn btn-ctrl dropdown-toggle"
              type="button"
              id="dropdownMenuButton"
              data-toggle="dropdown"
              aria-haspopup="true"
              aria-expanded="false"
            >Actions</button>
            <div class="dropdown-menu dropdown-menu-right" aria-labelledby="dropdownMenuButton">
              <a class="dropdown-item" href="#">Action</a>
              <a class="dropdown-item" href="#">Another action</a>
              <a class="dropdown-item" href="#">Something else here</a>
            </div>
          </div>&nbsp;
          <div class="btn-group" role="group" aria-label="Button group with nested dropdown">
            <button type="button" class="btn btn-ctrl">Print</button>
            <div class="btn-group" role="group">
              <button
                id="btnGroupDrop1"
                type="button"
                class="btn btn-ctrl dropdown-toggle"
                data-toggle="dropdown"
                aria-haspopup="true"
                aria-expanded="false"
              >Actions</button>
              <div class="dropdown-menu dropdown-menu-right" aria-labelledby="btnGroupDrop1">
                <a class="dropdown-item" href="#">Dropdown link</a>
                <a class="dropdown-item" href="#">Dropdown link</a>
              </div>
            </div>
          </div>

          <h5 class="mt-5">Segmented controls</h5>
            <fieldset>
              <legend class="sr-only">Visibility</legend>
              <div class="btn-group btn-group-toggle segmented-control">
                <label>
                  <input type="radio" name="options-v" id="all" checked="checked">
                  <span class="btn btn-ctrl" title="All tasks">All</span>
                </label>
                <label>
                  <input type="radio" name="options-v" id="mgr">
                  <span class="btn btn-ctrl" title="Manager">Manager</span>
                </label>
                <label>
                  <input type="radio" name="options-v" id="emp">
                  <span class="btn btn-ctrl" title="Employee">Employee</span>
                </label>
              </div>
            </fieldset>
            <br>
            <code>.segmented-control-inline</code>
            <fieldset>
              <legend class="sr-only">aria Summary</legend>
              <div class="segmented-control segmented-control-inline">
                <label>
                  <input type="radio" name="layout" id="value_1" value="value" checked>
                  <span title="Table View" class="btn btn-ctrl">
                    <i aria-hidden="true" aria-label="Table View" title="Table View" class="gel-icon-table"></i>
                  </span>
                </label>
                <label>
                  <input type="radio" name="layout" id="value_2" value="value">
                  <span title="Gallery View" class="btn btn-ctrl">
                    <i aria-hidden="true" aria-label="Gallery View" title="Gallery View" class="gel-icon-gallery"></i>
                    </span>
                  </label>
                </div>
              </fieldset>
              
             <h5 class="mt-5">Sizes</h5>
              <button type="button" class="btn btn-ctrl">
                <i aria-hidden="true" class="gel-icon-settings"></i>
                Default
              </button>&nbsp;
              <button type="button" class="btn btn-ctrl btn-sm">
                <i aria-hidden="true" class="gel-icon-settings"></i>
                Small
              </button>
              <h5 class="mt-5">Disabled</h5>
              <button class="btn btn-ctrl disabled" type="button">
                <i aria-hidden="true" class="gel-icon-settings"></i>
                Settings
              </button>
              <button type="button" class="btn btn-link disabled">Link button</button>
          </div>
      </div>  
    </div>
    <section class="md" v-html="mdfile"></section>
  </section>
</template>

<script>
import BSN from "bootstrap.native/dist/bootstrap-native-v4";
import mdfile from "@/docs/components/buttons.md";
export default {
  name: "buttons",
  beforeCreate: function() {
    this.$emit("update-title", this.$root.yamlData.components.buttons.name);
    this.$emit(
      "update-tagline",
      this.$root.yamlData.components.buttons.description
    );
  },
  mounted: function() {
    const dropdowns = document.querySelectorAll('[data-toggle="dropdown"]');
    dropdowns.forEach(dropdown => {
      new BSN.Dropdown(dropdown);
    });
    const icons = document.querySelectorAll('[data-toggle="tooltip"]');
    icons.forEach(icon => {
      new BSN.Tooltip(icon);
    });
  },
  data() {
    return {
      mdfile
    };
  }
};
</script>
